import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';

const showsEventData = [
  {
    id: 1,
    title: 'Electric Summer Festival',
    date: '2026-07-15',
    month: 'JUL',
    day: '15',
    time: '7:00 PM - 2:00 AM',
    location: 'Central Park, NYC',
    category: 'festivals',
    locationCode: 'nyc',
    badge: 'LIVE',
    price: '$89',
    description: 'The ultimate electronic music experience with top DJs from around the world',
    image: 'https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?w=800&q=80'
  },
  {
    id: 2,
    title: 'Neon Nights Concert',
    date: '2026-07-22',
    month: 'JUL',
    day: '22',
    time: '8:30 PM',
    location: 'Madison Square Garden',
    category: 'concerts',
    locationCode: 'nyc',
    badge: 'TRENDING',
    price: '$65',
    description: 'An unforgettable night of indie rock and alternative music',
    image: 'https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=800&q=80'
  },
  {
    id: 3,
    title: 'Sunset Jazz Festival',
    date: '2026-08-05',
    month: 'AUG',
    day: '05',
    time: '6:00 PM - 11:00 PM',
    location: 'Brooklyn Bridge Park',
    category: 'jazz',
    locationCode: 'nyc',
    badge: 'HOT',
    price: '$55',
    description: 'Smooth jazz vibes with legendary performers at sunset',
    image: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=800&q=80'
  },
  {
    id: 4,
    title: 'Rock Revolution Tour',
    date: '2026-08-12',
    month: 'AUG',
    day: '12',
    time: '7:30 PM',
    location: 'Barclays Center',
    category: 'rock',
    locationCode: 'nyc',
    badge: 'NEW',
    price: '$95',
    description: 'The biggest rock tour of the year with stadium performances',
    image: 'https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?w=800&q=80'
  },
  {
    id: 5,
    title: 'Urban Beats Showcase',
    date: '2026-08-20',
    month: 'AUG',
    day: '20',
    time: '9:00 PM - 1:00 AM',
    location: 'Brooklyn Steel',
    category: 'live-music',
    locationCode: 'nyc',
    badge: 'LIVE',
    price: '$45',
    description: 'Hip-hop and R&B artists performing their latest hits',
    image: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=800&q=80'
  },
  {
    id: 6,
    title: 'Indie Music Fest',
    date: '2026-09-01',
    month: 'SEP',
    day: '01',
    time: '5:00 PM - 11:00 PM',
    location: 'Prospect Park',
    category: 'festivals',
    locationCode: 'nyc',
    badge: 'FEATURED',
    price: '$39',
    description: 'Discover emerging indie artists and alternative bands',
    image: 'https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?w=800&q=80'
  }
];

function Shows({ showNotification }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('all');
  const [dateFilter, setDateFilter] = useState('all');
  const [locationFilter, setLocationFilter] = useState('all');
  const [viewMode, setViewMode] = useState('grid');
  const [email, setEmail] = useState('');

  const filteredEvents = useMemo(() => {
    let filtered = showsEventData;

    // Search filter
    if (searchTerm) {
      const lowerSearch = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (event) =>
          event.title.toLowerCase().includes(lowerSearch) ||
          event.description.toLowerCase().includes(lowerSearch) ||
          event.location.toLowerCase().includes(lowerSearch)
      );
    }

    // Category filter
    if (categoryFilter !== 'all') {
      filtered = filtered.filter((event) => event.category === categoryFilter);
    }

    // Location filter
    if (locationFilter !== 'all') {
      filtered = filtered.filter((event) => event.locationCode === locationFilter);
    }

    // Date filter would be more complex in a real app
    // For now, just include all upcoming events

    return filtered;
  }, [searchTerm, categoryFilter, locationFilter]);

  const handleBuyTickets = (eventTitle) => {
    showNotification(`Redirecting to tickets for "${eventTitle}"...`, 'info');
    setTimeout(() => {
      console.log('Opening ticket purchase for:', eventTitle);
    }, 1000);
  };

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (email) {
      showNotification('Thank you for subscribing! Check your inbox for confirmation.', 'success');
      setEmail('');
    }
  };

  return (
    <main>
      {/* Page Header */}
      <section className="page-header">
        <div className="page-header-content">
          <h1 className="page-title">All Shows</h1>
          <p className="page-subtitle">Discover amazing live events and book your tickets instantly</p>
        </div>
      </section>

      {/* Filter & Search Section */}
      <section className="filter-section">
        <div className="container">
          <div className="filter-bar">
            <div className="search-box">
              <i className="fas fa-search"></i>
              <input
                type="text"
                placeholder="Search events, artists, venues..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="filter-group">
              <select
                className="filter-select"
                value={categoryFilter}
                onChange={(e) => setCategoryFilter(e.target.value)}
              >
                <option value="all">All Categories</option>
                <option value="concerts">Concerts</option>
                <option value="festivals">Festivals</option>
                <option value="live-music">Live Music</option>
                <option value="jazz">Jazz</option>
                <option value="rock">Rock</option>
                <option value="electronic">Electronic</option>
              </select>

              <select
                className="filter-select"
                value={dateFilter}
                onChange={(e) => setDateFilter(e.target.value)}
              >
                <option value="all">All Dates</option>
                <option value="today">Today</option>
                <option value="week">This Week</option>
                <option value="month">This Month</option>
                <option value="upcoming">Upcoming</option>
              </select>

              <select
                className="filter-select"
                value={locationFilter}
                onChange={(e) => setLocationFilter(e.target.value)}
              >
                <option value="all">All Locations</option>
                <option value="nyc">New York City</option>
                <option value="la">Los Angeles</option>
                <option value="chicago">Chicago</option>
                <option value="miami">Miami</option>
              </select>
            </div>
          </div>
        </div>
      </section>

      {/* All Events Listing */}
      <section className="all-events">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">All Upcoming Events</h2>
            <div className="view-toggle">
              <button
                className={`btn-view ${viewMode === 'grid' ? 'active' : ''}`}
                onClick={() => setViewMode('grid')}
              >
                <i className="fas fa-th"></i> Grid
              </button>
              <button
                className={`btn-view ${viewMode === 'list' ? 'active' : ''}`}
                onClick={() => setViewMode('list')}
              >
                <i className="fas fa-list"></i> List
              </button>
            </div>
          </div>

          <div className={`events-container ${viewMode === 'grid' ? 'grid-view' : 'list-view'}`}>
            {filteredEvents.map((event) => (
              <div key={event.id} className="event-card-large">
                <div className="event-image" style={{ backgroundImage: `url('${event.image}')` }}>
                  <div className="event-badge">{event.badge}</div>
                </div>
                <div className="event-info">
                  <div className="event-date-badge">
                    <span className="date-month">{event.month}</span>
                    <span className="date-day">{event.day}</span>
                  </div>
                  <h3 className="event-title">{event.title}</h3>
                  <p className="event-description">{event.description}</p>
                  <div className="event-details">
                    <div className="event-detail">
                      <i className="far fa-clock"></i>
                      <span>{event.time}</span>
                    </div>
                    <div className="event-detail">
                      <i className="fas fa-map-marker-alt"></i>
                      <span>{event.location}</span>
                    </div>
                  </div>
                  <div className="event-footer">
                    <div className="event-price">From {event.price}</div>
                    <button className="btn-tickets" onClick={() => handleBuyTickets(event.title)}>
                      Buy Tickets
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredEvents.length === 0 && (
            <div style={{ textAlign: 'center', padding: '60px 0', color: '#B0B0B0' }}>
              <i className="fas fa-search" style={{ fontSize: '48px', marginBottom: '20px', display: 'block' }}></i>
              <p>No events found matching your criteria. Try adjusting your filters.</p>
            </div>
          )}

          {filteredEvents.length > 0 && (
            <div className="load-more-container">
              <button className="btn-load-more">Load More Events</button>
            </div>
          )}
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="newsletter">
        <div className="container">
          <div className="newsletter-card">
            <h2 className="newsletter-title">Stay Up To Date</h2>
            <p className="newsletter-text">Get notified about new events, exclusive presales, and special offers.</p>
            <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
              <input
                type="email"
                placeholder="Enter your email"
                className="newsletter-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="btn-subscribe">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h3 className="footer-title">WHOOPPE</h3>
              <p className="footer-description">Biometric event ticketing technology. Enter any event with just your face.</p>
            </div>

            <div className="footer-column">
              <h4 className="footer-heading">Company</h4>
              <ul className="footer-links">
                <li>
                  <a href="#/">About Woopy</a>
                </li>
                <li>
                  <a href="#/">Careers</a>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
                <li>
                  <a href="#/">Press</a>
                </li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-heading">For Organizers</h4>
              <ul className="footer-links">
                <li>
                  <a href="#/">List Your Show</a>
                </li>
                <li>
                  <a href="#/">Partner with Us</a>
                </li>
                <li>
                  <a href="#/">Technology</a>
                </li>
                <li>
                  <a href="#/">Pricing</a>
                </li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-heading">Legal</h4>
              <ul className="footer-links">
                <li>
                  <a href="#/">Privacy Policy</a>
                </li>
                <li>
                  <a href="#/">Terms & Conditions</a>
                </li>
                <li>
                  <a href="#/">Cookie Policy</a>
                </li>
                <li>
                  <a href="#/">Security</a>
                </li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-heading">Download the App</h4>
              <p className="footer-app-text">Get the Whooppe app for seamless event experiences.</p>
              <a href="https://play.google.com/store/apps/details?id=com.thrillathon.whooppeapp" target="_blank" rel="noopener noreferrer" className="btn-footer-download">
                <i className="fab fa-google-play"></i>
                <div className="btn-text">
                  <span className="btn-small">GET IT ON</span>
                  <span className="btn-large">Google Play</span>
                </div>
              </a>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2026 Whooppe · Thrillathon Technologies. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </main>
  );
}

export default Shows;
